import { TabPanel, TabView } from "primereact/tabview";
import { useEffect, useState } from "react";
import { PlanAccionistaService } from "../../service/matriz/PlanAccionistaService";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Evaluacion } from "../../models/matriz/Evaluacion";
import { InputComponent } from "../../components/InputComponent";
import { useForm } from "react-hook-form";

const accionistaSrv = new PlanAccionistaService();

export const AccionistaFactor = ({ plantilla, toast, generic, permss }) => {
    const omodel = new Evaluacion();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, clearErrors } = useForm({ defaultValues });
    const [seniales, setSeniales] = useState([]);
    const [senial, setSenial] = useState(null);
    const [evaluaciones, setEvaluaciones] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const [activeTab, setActiveTab] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingContent, setLoadingContent] = useState(false);
    const { inNumber } = InputComponent({ omodel, generic, errors, control, permss, id: getValues('id') });
    const _tipos = [
        { tipo: "MATRIZ_TIPO_UN_ANIO", icon: "pi pi-euro ml-2", header: "ANÁLISIS UN AÑO" },
        { tipo: "MATRIZ_TIPO_DOS_ANIOS", icon: "pi pi-calendar-plus ml-2", header: "ANÁLISIS DOS AÑOS" }
    ];

    useEffect(() => {
        consultarSenial();
    }, [plantilla]);

    const consultarSenial = (_inx = 0) => {
        setActiveTab(_inx);
        setLoading(true);
        setActiveIndex(null);
        setEvaluaciones(null);
        accionistaSrv
            .consultarSenial(plantilla, _tipos[_inx].tipo)
            .then((res) => setSeniales(res.data))
            .catch(() => showError())
            .finally(() => setLoading(false));
    };

    const onTabChange = (e) => {
        const newIndex = e.index;

        // Si el usuario cierra el mismo tab abierto, limpiar
        if (newIndex === activeIndex) {
            setActiveIndex(null);
            setEvaluaciones(null);
            return;
        }

        const _senial = seniales[newIndex];
        setActiveIndex(newIndex);
        setEvaluaciones(null);    // limpia contenido anterior mientras carga
        reset();                  // resetea el form al cambiar de tab

        setLoadingContent(true);
        setSenial(_senial);
        accionistaSrv
            .consultarEvaluacion(plantilla, _tipos[activeTab].tipo, _senial.id)
            .then(res => {
                const _data = res.data;
                _data.forEach(item => {
                    item.maximo = parseFloat(item.maximo);
                    item.minimo = parseFloat(item.minimo);
                });
                setEvaluaciones(res.data);
                const _res = {};
                _data.forEach(item => {
                    _res['nivel' + item.nivel] = item.maximo;
                });
                reset(_res);
            })
            .catch(() => showError())
            .finally(() => setLoadingContent(false));
    };

    const showError = () => {
        toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "No se puede consultar la información, por favor intente nuevamente más tarde",
            life: 3000,
        });
    };

    const onSubmit = (data) => {
        data.idp = senial.id;
        setLoading(true);
        accionistaSrv.registrarEvaluacion(data).then(res => {
            generic.funcSuccess(res, toast);
            //consultarSenial();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setLoading(false));
    };

    const onChangeValues = (evt, inx) => {
        const _eva = [...evaluaciones];
        _eva[inx].maximo = evt.value;

        const rules = [
            [
                'nivel1',
                () => _eva[0].maximo >= _eva[1].maximo,
                () => `No puede ser mayor a ${_eva[1].maximo}`,
            ],
            [
                'nivel2',
                () => _eva[1].maximo >= _eva[2].maximo || _eva[1].maximo < _eva[0].maximo,
                () => `Debe estar entre ${_eva[0].maximo} y ${_eva[2].maximo}`,
            ],
            [
                'nivel3',
                () => _eva[2].maximo >= _eva[3].maximo || _eva[2].maximo < _eva[1].maximo,
                () => `Debe estar entre ${_eva[1].maximo} y ${_eva[3].maximo}`,
            ],
            [
                'nivel4',
                () => _eva[3].maximo < _eva[2].maximo,
                () => `Debe ser mayor a ${_eva[2].maximo}`,
            ],
        ];

        clearErrors(['nivel1', 'nivel2', 'nivel3', 'nivel4']);
        rules.forEach(([campo, esInvalido, mensaje]) => {
            if (esInvalido()) setError(campo, { type: 'manual', message: mensaje() });
        });

        setEvaluaciones(_eva);
    };

    const contentEvaluacion = () => {
        if (loadingContent) return <p className="m-0">Cargando evaluación...</p>;
        if (!evaluaciones) return <p className="m-0">Sin datos.</p>;

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formgrid grid">
                    <div className="field col-2">≤</div>
                    {inNumber('nivel1', 0, false, { func: onChangeValues, vars: 0 })}
                    <div className="field col-4">(coherente) → 1 - muy bajo</div>
                    <div className="field col-2"></div>

                    <div className="field col-2">{evaluaciones[0]?.maximo} - </div>
                    {inNumber('nivel2', 0, false, { func: onChangeValues, vars: 1 })}
                    <div className="field col-4"> → 2 - bajo</div>
                    <div className="field col-2"></div>

                    <div className="field col-2">{evaluaciones[1]?.maximo} -</div>
                    {inNumber('nivel3', 0, false, { func: onChangeValues, vars: 2 })}
                    <div className="field col-4"> → 3 - medio</div>
                    <div className="field col-2"></div>

                    <div className="field col-2">{evaluaciones[2]?.maximo} -</div>
                    {inNumber('nivel4', 0, false, { func: onChangeValues, vars: 3 })}
                    <div className="field col-4"> → 4 - alto</div>
                    <div className="field col-2"></div>

                    <div className="field col-2">&gt;</div>
                    <div className="field col-3">{evaluaciones[3]?.maximo} -</div>
                    <div className="field col-4"> → 5 - muy alto</div>
                    <div className="field col-2"></div>
                </div>

                {generic.buttonsForms()}
            </form>
        );
    };

    return (
        <TabView activeIndex={activeTab} onTabChange={e => consultarSenial(e.index)}>
            {_tipos.map((itm) => (
                <TabPanel header={itm.header} rightIcon={itm.icon} key={itm.tipo}>
                    {loading ? (
                        <p className="m-0">Cargando...</p>
                    ) : (
                        <Accordion activeIndex={activeIndex} onTabChange={onTabChange}>
                            {seniales.map((item) => (
                                <AccordionTab key={item.id} header={item.nombre}>
                                    {activeIndex === seniales.indexOf(item) && contentEvaluacion()}
                                </AccordionTab>
                            ))}
                        </Accordion>
                    )}
                </TabPanel>
            ))}
        </TabView>
    );
};